<template>
  <piece-card title="部门通知">
    <div class="notice-box">
      <div class="notice-list">
        <div class="notice-item flex-box" v-for="item in noticeList" :key="item.id">
          <img src="@/assets/classroom/notice_icon.png" class="notice-icon" />
          <div class="notice-text three-ellipsis">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </piece-card>
</template>

<script>
import PieceCard from "../../components/piece-card.vue";

export default {
  name: "Notice",
  components: {
    PieceCard,
  },
  props: {
    info: { type: Object },
  },
  computed: {
    noticeList() {
      return this.info?.notice?.length ? this.info.notice : [{ id: 1, title: "暂无通知" }];
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.notice-box {
  padding: 26px 12px 8px;
  margin: 16px 0 0;
  width: 475px;
  height: 99px;
  background: url(../../../../../assets/classroom/notice_box.png) center / contain no-repeat;
}
.notice-list {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
.notice-item {
  &:not(:last-of-type) {
    margin-bottom: 8px;
  }
}
.notice-icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  object-fit: contain;
  margin-right: 12px;
}
.notice-text {
  flex: 1;
  min-width: 0;
  color: #feffff;
  font-family: "Source Han Sans CN";
  font-size: 16px;
}
</style>
